import MuiBox from '@mui/material/Box';

export const Box = MuiBox;
